import React from 'react';
import { DEFAULT_MESSAGES } from '../../../../const/constants.js';

/**
 * 深度思考中状态组件
 */
export const DeepSeekingCom = ({ msg = DEFAULT_MESSAGES.DEEP_SEEKING }) => {
  return (
    <div className="ocrDemo-seeking-container">
      <div className="ocrDemo-icon-seeking"></div>
      <div className="ocrDemo-seeking__text">{msg}</div>
    </div>
  );
};

/**
 * 识别中状态组件
 */
export const ResultingCom = ({ msg = DEFAULT_MESSAGES.RESULTING }) => {
  return (
    <div className="ocrDemo-resulting-container">
      <div className="ocrDemo-icon-resulting"></div>
      <div className="ocrDemo-resulting__text">{msg}</div>
    </div>
  );
};

/**
 * 空结果状态组件
 */
export const EmptyCom = ({ msg = DEFAULT_MESSAGES.EMPTY_RESULT }) => {
  return (
    <div className="ocrDemo-empty-container">
      <div className="ocrDemo-icon-empty"></div>
      <div className="ocrDemo-empty__text">{msg}</div>
    </div>
  );
};
